import PaginatedList from "@theme/paginated-list";

/**
 * A custom element that renders a paginated collections list.
 */
export default class CollectionsList extends PaginatedList {}

if (!customElements.get("collections-list")) {
  customElements.define("collections-list", CollectionsList);
}
